import * as RouteDefinition from '../Data/RouteDefinition'

export type M =
    | Root
    | OrderOverview
    | OrderDetails
    | PasswordChange
    | OrderCreate
    | InquiryOverview
    | InquiryDetails
    | OrderExportCreate
    | ProductCalculationOverview
    | ProductCalculationDetails
    | ProductCalculationImport
    | OrderExportCreate
    | OrderExportCreateFromTemplate
    | OrderExportOverview
    | PrismaRequestOverview
    | PrismaRequestDetails

interface Root {
    readonly type: 'Root'
}

interface OrderOverview {
    readonly type: 'OrderOverview'
}

interface OrderDetails {
    readonly type: 'OrderDetails'
    readonly orderNumber: string
}

interface PasswordChange {
    readonly type: 'PasswordChange'
}

interface OrderCreate {
    readonly type: 'OrderCreate'
}

interface InquiryOverview {
    readonly type: 'InquiryOverview'
}

interface InquiryDetails {
    readonly type: 'InquiryDetails'
    readonly inquiryNumber: number
}

interface OrderExportCreate {
    readonly type: 'OrderExportCreate'
}

interface OrderExportCreateFromTemplate {
    readonly type: 'OrderExportCreateFromTemplate'
    readonly id: number
}

interface OrderExportOverview {
    readonly type: 'OrderExportOverview'
}

interface ProductCalculationOverview {
    readonly type: 'ProductCalculationOverview'
}

interface ProductCalculationImport {
    readonly type: 'ProductCalculationImport'
}

interface ProductCalculationDetails {
    readonly type: 'ProductCalculationDetails'
    readonly id: number
}

interface PrismaRequestOverview {
    readonly type: 'PrismaRequestOverview'
}

interface PrismaRequestDetails {
    readonly type: 'PrismaRequestDetails'
    readonly id: number
}

export const definitions: RouteDefinition.M<M>[] = [
    {
        pattern: /^$/,
        constructor: () => ({type: 'Root'}),
    },
    {
        pattern: /^\/orders$/,
        constructor: () => ({type: 'OrderOverview'}),
    },
    {
        pattern: /^\/orders\/(\d+)$/,
        constructor: ([orderNumber]) => ({
            type: 'OrderDetails',
            orderNumber: orderNumber,
        }),
    },
    {
        pattern: /^\/password-change$/,
        constructor: () => ({type: 'PasswordChange'}),
    },
    {
        pattern: /^\/orders\/create$/,
        constructor: () => ({type: 'OrderCreate'}),
    },
    {
        pattern: /^\/inquiries$/,
        constructor: () => ({type: 'InquiryOverview'})
    },
    {
        pattern: /^\/inquiries\/(\d+)$/,
        constructor: ([inquiryNumber]) => ({
            type: 'InquiryDetails',
            inquiryNumber: parseInt(inquiryNumber, 10),
        })
    },
    {
        pattern: /^\/order-exports\/create$/,
        constructor: () => ({type: 'OrderExportCreate'}),
    },
    {
        pattern: /^\/order-exports\/(\d+)\/create$/,
        constructor: ([id]) => ({
            type: 'OrderExportCreateFromTemplate',
            id: parseInt(id, 10),
        })
    },
    {
        pattern: /^\/order-exports$/,
        constructor: () => ({type: 'OrderExportOverview'}),
    },
    {
        pattern: /^\/product-calculations$/,
        constructor: () => ({type: 'ProductCalculationOverview'})
    },
    {
        pattern: /^\/product-calculations\/(\d+)$/,
        constructor: ([id]) => ({
            type: 'ProductCalculationDetails',
            id: parseInt(id, 10),
        })
    },
    {
        pattern: /^\/product-calculations\/import$/,
        constructor: () => ({type: 'ProductCalculationImport'})
    },
    {
        pattern: /^\/prisma-request-offers$/,
        constructor: () => ({type: 'PrismaRequestOverview'})
    },
    {
        pattern: /^\/prisma-requests\/(\d+)$/,
        constructor: ([id]) => ({
            type: 'PrismaRequestDetails',
            id: Number(id),
        })
    },
]

export function url(route: M): string {
    switch (route.type) {
        case 'Root':
            return ''
        case 'OrderOverview':
            return '#/orders'
        case 'OrderDetails':
            return `#/orders/${route.orderNumber}`
        case 'PasswordChange':
            return '#/password-change'
        case 'OrderCreate':
            return '#/orders/create'
        case 'InquiryOverview':
            return '#/inquiries'
        case 'InquiryDetails':
            return `#/inquiries/${route.inquiryNumber}`
        case 'OrderExportCreate':
            return '#/order-exports/create'
        case 'OrderExportCreateFromTemplate':
            return `#/order-exports/${route.id}/create`
        case 'OrderExportOverview':
            return '#/order-exports'
        case 'ProductCalculationOverview':
            return '#/product-calculations'
        case 'ProductCalculationDetails':
            return `#/product-calculations/${route.id}`
        case 'ProductCalculationImport':
            return '#/product-calculations/import'
        case 'PrismaRequestOverview':
            return '#/prisma-request-offers'
        case 'PrismaRequestDetails':
            return `#/prisma-requests/${route.id}`
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App/AuthenticatedRoute.ts